import { useUserActiveBans } from './useUserActiveBans';
export function useIsUserBannedOnChannel(userId, channel) {
    const { bans, refreshItems, asyncStatus } = useUserActiveBans(userId);
    return {
        isBanned: bans.findIndex((ban) => ban.channel === channel) >= 0,
        refreshStatus: refreshItems,
        asyncStatus,
    };
}
